<!-- eslint-disable vue/require-v-for-key -->
<template>
  <nav class="sidebar">
    <ul class="nav_list">
      <!-- 즐겨찾기 섹션 -->
      <div v-if="!isSiteOverlink" class="favorite-section">
        <div
          class="nav_group_header"
          @click="toggleFavoriteGroup"
        >
          <h3>자주사용메뉴</h3>
          <svg
            class="chevron-icon"
            :class="{ 'rotated': isFavoriteExpanded }"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 12L10 8L6 4"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <transition name="slide-fade">
          <div
            v-if="isFavoriteExpanded"
            class="nav_group_items favorite-items"
          >
            <template v-if="favoriteMenus.length > 0">
              <template v-for="(fav, favIndex) in favoriteMenus">
                <li
                  :key="'fav-' + favIndex"
                  class="nav favorite-nav"
                  :class="{ 
                    selected: $route.name === fav.menuRouteName
                  }"
                >
                  <div class="nav-item-wrapper">
                    <router-link
                      v-if="fav.menuRouteName && fav.menuRouteName !== '#'"
                      :to="`/app/${fav.menuLink}`"
                      class="nav-link"
                    >
                      <SVGComponent :name="fav.menuImage || 'settings'" />
                      <p>{{ fav.menuName }}</p>
                    </router-link>
                    <a v-else :href="fav.menuLink" target="_blank" class="nav-link">
                      <SVGComponent :name="fav.menuImage || 'settings'" />
                      <p>{{ fav.menuName }}</p>
                    </a>
                    <button
                      @click.prevent="removeFavorite(fav.idx)"
                      class="remove-favorite-btn"
                      :title="'자주사용메뉴에서 제거'"
                    >
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5" stroke="currentColor" stroke-width="1.5"
                              stroke-linecap="round" />
                      </svg>
                    </button>
                  </div>
                </li>
              </template>
            </template>
            <div v-else class="empty-favorite-message">
              <p>자주사용메뉴가 없습니다.</p>
            </div>
          </div>
        </transition>
      </div>

      <!-- 현재 메뉴를 즐겨찾기에 추가 버튼 -->
      <div
        v-if="!isSiteOverlink && currentMenu && !isCurrentMenuFavorite"
        class="add-favorite-section"
      >
        <button
          @click="addCurrentMenuToFavorite"
          class="add-favorite-btn"
          :title="'현재 메뉴를 자주사용메뉴에 추가'"
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 2L9.5 6L14 7L9.5 8L8 12L6.5 8L2 7L6.5 6L8 2Z" fill="currentColor" stroke="currentColor"
                  stroke-width="1" />
          </svg>
          <span>자주사용메뉴에 추가</span>
        </button>
      </div>

      <!-- 디버깅: currentMenu 정보 표시 (개발용) -->
      <!-- <div v-if="!currentMenu" class="add-favorite-section">
        <div style="color: #fff; font-size: 12px; padding: 8px;">
          현재 라우트: {{ $route.name }}<br>
          currentMenu: {{ currentMenu ? currentMenu.name : '없음' }}
        </div>
      </div> -->

      <!-- 모두펼치기/모두닫기 버튼 -->
      <div v-if="!isSiteOverlink" class="expand-control-section">
        <button
          @click="expandAllGroups"
          class="expand-control-btn"
          :title="'모든 메뉴 펼치기'"
        >
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 1L7 13M1 7L13 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          </svg>
          <span>모두펼치기</span>
        </button>
        <button
          @click="collapseAllGroups"
          class="expand-control-btn"
          :title="'모든 메뉴 닫기'"
        >
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 7L13 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          </svg>
          <span>모두닫기</span>
        </button>
      </div>


      <template v-for="(group, groupIndex) in navListProcessed">
        <div
          v-bind:key="'group-' + groupIndex"
          class="nav_group_header"
          @click="toggleGroup(groupIndex)"
        >
          <h3>{{ group.group }}</h3>
          <svg
            class="chevron-icon"
            :class="{ 'rotated': expandedGroups[groupIndex] }"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 12L10 8L6 4"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <transition name="slide-fade">
          <div
            v-if="expandedGroups[groupIndex] !== false"
            class="nav_group_items"
            :class="{ 'one-line': group.group === '고객센터' }"
          >
            <template v-for="(nav, navIndex) in group.items">
              <li
                v-if="nav.name !== '[새창 열기]'"
                :key="'nav-' + groupIndex + '-' + navIndex"
                class="nav"
                :class="{ 
                  selected: $route.name === nav.routeName
                }"
              >
                <div class="nav-item-wrapper">
                  <router-link
                    v-if="nav.routeName !== '#'"
                    :to="`/app/${nav.link}`"
                    class="nav-link"
                    :event="getNavClickEvent(nav)"
                    @click.native="handleNavClick($event, nav)"
                  >
                    <SVGComponent :name="nav.image" />
                    <p>{{ nav.name }}</p>
                    <a
                      v-if="group.items[navIndex + 1] && group.items[navIndex + 1].name === '[새창 열기]'"
                      href="javascript:void(0)"
                      @click.stop.prevent="handleNewTabClick(group.items[navIndex + 1], nav)"
                      class="external-link-icon-inline"
                      :title="'새창으로 열기'"
                    >
                      <SVGComponent :name="'externalLink'" />
                    </a>
                  </router-link>
                  <a v-else :href="nav.link" target="_blank" class="nav-link">
                    <SVGComponent :name="nav.image" />
                    <p>{{ nav.name }}</p>
                    <a
                      v-if="group.items[navIndex + 1] && group.items[navIndex + 1].name === '[새창 열기]'"
                      href="javascript:void(0)"
                      @click.stop.prevent="handleNewTabClick(group.items[navIndex + 1], nav)"
                      class="external-link-icon-inline"
                      :title="'새창으로 열기'"
                    >
                      <SVGComponent :name="'externalLink'" />
                    </a>
                  </a>
                </div>
              </li>
            </template>
          </div>
        </transition>
      </template>
    </ul>
  </nav>
</template>

<script>
import SVGComponent from '@/components/common/SVGComponent';
import { templateApi } from '@/api/template';
import { paymentAPI } from '@/api';
import { useCommonStore } from '@/stores/common';

export default {
  components: {
    SVGComponent
  },
  computed: {
    common() {
      return useCommonStore();
    }
  },
  methods: {
    toggleGroup(groupIndex) {
      // 그룹 접기/펼치기 토글
      this.$set(this.expandedGroups, groupIndex, !this.expandedGroups[groupIndex]);
    },
    expandAllGroups() {
      // 모든 그룹 펼치기
      this.navListProcessed.forEach((group, index) => {
        this.$set(this.expandedGroups, index, true);
      });
      this.isFavoriteExpanded = true;
    },
    collapseAllGroups() {
      // 모든 그룹 닫기
      this.navListProcessed.forEach((group, index) => {
        this.$set(this.expandedGroups, index, false);
      });
      this.isFavoriteExpanded = false;
    },
    toggleFavoriteGroup() {
      // 즐겨찾기 그룹 접기/펼치기 토글
      this.isFavoriteExpanded = !this.isFavoriteExpanded;
    },
    async loadFavoriteMenus() {
      try {
        const res = await templateApi.GetFavoriteMenuList();
        if (res.status === 'Success' && res.data) {
          this.favoriteMenus = res.data;
        }
      } catch (error) {
        console.error('즐겨찾기 메뉴 로드 실패:', error);
      }
    },
    async addCurrentMenuToFavorite() {
      if (!this.currentMenu) return;

      try {
        const menuData = {
          menuName: this.currentMenu.name,
          menuLink: this.currentMenu.link,
          menuRouteName: this.currentMenu.routeName || '#',
          menuImage: this.currentMenu.image || 'settings'
        };

        const res = await templateApi.AddFavoriteMenu(menuData);
        if (res.status === 'Success') {
          this.common.setToast('green', 'good', '자주사용메뉴에 추가되었습니다.');
          await this.loadFavoriteMenus();
        } else {
          this.common.setToast('red', 'discontent', res.message || '추가에 실패했습니다.');
        }
      } catch (error) {
        console.error('즐겨찾기 추가 실패:', error);
        this.common.setToast('red', 'discontent', '자주사용메뉴 추가에 실패했습니다.');
      }
    },
    async removeFavorite(idx) {
      if (!confirm('자주사용메뉴에서 제거하시겠습니까?')) return;

      try {
        const res = await templateApi.DeleteFavoriteMenu(idx);
        if (res.status === 'Success') {
          this.common.setToast('green', 'good', '자주사용메뉴에서 제거되었습니다.');
          await this.loadFavoriteMenus();
        } else {
          this.common.setToast('red', 'discontent', res.message || '제거에 실패했습니다.');
        }
      } catch (error) {
        console.error('즐겨찾기 제거 실패:', error);
        this.common.setToast('red', 'discontent', '자주사용메뉴 제거에 실패했습니다.');
      }
    },
    showComingSoon() {
      alert('준비중입니다.');
    },
    openInNewTab(path) {
      const route = this.$router.resolve(path);
      // href가 이미 전체 URL이거나 상대 경로일 수 있으므로 확인
      let fullUrl = route.href;
      if (fullUrl.startsWith('/')) {
        fullUrl = window.location.origin + fullUrl;
      }
      window.open(fullUrl, '_blank');
    },
    handleNewTabClick(newTabItem, currentItem) {
      // 재고관리 새창 열기 → stock.overlink.kr 자동로그인
      if (currentItem.link === 'inventoryLinked') {
        this.openStockOverlink();
        return;
      }
      if (currentItem.routeName !== '#') {
        // 라우터 링크인 경우 - currentItem의 링크 사용 (_blank 제거된 실제 경로)
        this.openInNewTab(`/app/${currentItem.link}`);
      } else {
        // 외부 링크인 경우
        window.open(currentItem.link, '_blank');
      }
    },
    openStockOverlink() {
      const userId = localStorage.getItem('loginUserId');
      const pw = sessionStorage.getItem('__lp');
      if (!userId || !pw) {
        alert('로그인 정보를 찾을 수 없습니다. 다시 로그인해주세요.');
        return;
      }
      const url = `https://stock.overlink.kr/?auid=${encodeURIComponent(userId)}&apw=${encodeURIComponent(pw)}`;
      window.open(url, '_blank');
    },
    getNavClickEvent(nav) {
      // 재고관리 특수 처리
      if (nav.link === 'inventoryLinked' && !this.isSiteOverlink) {
        return '';
      }
      return 'click';
    },
    handleNavClick(event, nav) {
      // 재고관리 특수 처리
      if (nav.link === 'inventoryLinked' && !this.isSiteOverlink) {
        this.openStockOverlink();
        return;
      }
    },
    initializeExpandedGroups() {
      // 모든 그룹을 기본적으로 펼침 상태로 초기화
      this.navListProcessed.forEach((group, index) => {
        this.$set(this.expandedGroups, index, true);
      });
    }
  },
  watch: {
    navListProcessed: {
      handler() {
        // navListProcessed가 변경될 때 그룹 상태 초기화
        this.$nextTick(() => {
          this.initializeExpandedGroups();
        });
      },
      immediate: true
    }
  },
  async mounted() {
    const userInfo = await templateApi.GetUserInfo();
    if (userInfo.status === 'Success') {
      this.userInfo = userInfo.data;
    }
    await this.loadFavoriteMenus();
  },
  computed: {
    isDomesinOnly() {
      // authStore.user 또는 localStorage에서 isDomesinOnly 확인
      const user = this.authStore?.user;
      if (user && user.isDomesinOnly) {
        return true;
      }
      try {
        const storedUser = JSON.parse(localStorage.getItem('user') || 'null');
        if (storedUser && storedUser.isDomesinOnly) {
          return true;
        }
      } catch (e) {
        // 무시
      }
      return false;
    },
    menuname() {
      const host = window.location.hostname;

      if (host.includes('omarket.kr')) {
        return '셀리오마켓';
      } else if (host.includes('daenlabs.kr')) {
        return '시행착오랩';
      } else if (host.includes('kimmanager.co.kr')) {
        return '김매니저';
      } else if (host.includes('connectone07.co.kr')) {
        return '커넥트원';
      } else if (host.includes('kcode.store')) {
        return '케이코드';
      } else if (host.includes('crosssell.co.kr')) {
        return '크로스셀';
      } else if (host.includes('overlink.kr')) {
        return '오버링크';
      } else if (host.includes('zijyasssssell.com')) {
        return '지쟈스';
      } else if (host.includes('osonupload.com')) {
        return '오손업로드';
      } else if (host.includes('smartcross.kr')) {
        return '스마트크로스';
      } else {
        return '파트너스';
      }
    },
    // 링크 대체 맵핑
    domainLinkOverrides() {
      return {
        'omarket.kr': {
          talkName: '상담하러가기',
          kakaoName: '셀리오마켓 오픈채팅 ',
          cafeName: '셀리오마켓 카페',
          link1Name: '',
          channelTalk: 'http://pf.kakao.com/_sGRqX/chat',
          kakaoChat: 'https://open.kakao.com/o/gcKor9Jh',
          naverCafe: 'https://cafe.naver.com/overlink',
          Link1Image: ''
        },
        'daenlabs.kr': {
          talkName: '상담하러가기',
          kakaoName: '시행착오랩 오픈채팅',
          cafeName: '시행착오랩 카페',
          link1Name: '',
          channelTalk: 'https://cafe.naver.com/sihaengchako',
          kakaoChat: 'https://litt.ly/shco',
          naverCafe: 'https://cafe.naver.com/sihaengchako',
          link1Link: '',
          Link1Image: ''
        },
        'kimmanager.co.kr': {
          talkName: '상담하러가기',
          kakaoName: '김매니저 오픈채팅',
          cafeName: '김매니저 카페',
          link1Name: '',
          channelTalk: 'http://pf.kakao.com/_sGRqX/chat',
          kakaoChat: 'https://open.kakao.com/o/gqU7iBXh\n',
          naverCafe: 'https://cafe.naver.com/jeonggoonedu',
          link1Link: '',
          Link1Image: ''
        },
        'connectone07.co.kr': {
          talkName: '상담하러가기',
          kakaoName: '임반장 강의신청톡',
          cafeName: '임반장 카페',
          link1Name: '쿠팡 광고효율업 세이비',
          channelTalk: 'https://open.kakao.com/o/gOTHDDEh',
          kakaoChat: 'https://open.kakao.com/o/s8nGgMAg',
          naverCafe: 'https://cafe.naver.com/imcaptain',
          link1Link: 'https://m.site.naver.com/1G6ct',
          Link1Image: 'naverCafe'
        },
        'kcode.store': {
          talkName: '상담하러가기',
          kakaoName: '',
          cafeName: '',
          link1Name: '',
          channelTalk: '',
          kakaoChat: '',
          naverCafe: 'https://cafe.naver.com/matthesmoney',
          link1Link: '',
          Link1Image: ''
        },
        'crosssell.co.kr': {
          talkName: '상담하러가기',
          kakaoName: '',
          cafeName: '',
          link1Name: '',
          channelTalk: '',
          kakaoChat: '',
          naverCafe: '',
          link1Link: '',
          Link1Image: ''
        },
        'overlink.kr': {
          talkName: '상담하러가기',
          kakaoName: '',
          cafeName: '',
          link1Name: '',
          channelTalk: 'http://pf.kakao.com/_sGRqX/chat',
          kakaoChat: 'https://open.kakao.com/o/gcKor9Jh',
          naverCafe: 'https://cafe.naver.com/overlink',
          link1Link: '',
          Link1Image: ''
        },
        'zijyasssssell.com': {
          talkName: '상담하러가기',
          kakaoName: '오픈채팅방',
          cafeName: '지쟈쓰네이버카페',
          link1Name: '',
          channelTalk: 'https://pf.kakao.com/_BIExexj',
          kakaoChat: 'https://open.kakao.com/o/gkbzrHNg',
          naverCafe: 'https://cafe.naver.com/zijyasssss',
          link1Link: '',
          Link1Image: ''
        },
        'osonupload.com': {
          talkName: '상담하러가기',
          kakaoName: '오픈채팅방',
          cafeName: '네이버카페',
          link1Name: '',
          channelTalk: 'http://pf.kakao.com/_Nmwun',
          kakaoChat: 'http://pf.kakao.com/_Nmwun',
          naverCafe: 'https://cafe.naver.com/ohline1998',
          link1Link: '',
          Link1Image: ''
        },
        'localhost': {
          talkName: 'Localhost상담하러가기',
          kakaoName: 'https://solutionno1.channel.io',
          cafeName: 'Localhost카페',
          link1Name: '링크2',
          channelTalk: 'Localhost채널',
          kakaoChat: 'https://open.kakao.com/o/example5',
          naverCafe: 'https://cafe.naver.com/example5',
          link1Link: '',
          Link1Image: 'naverCafe'
        },
        'smartcross.kr': {
          talkName: '상담하러가기',
          kakaoName: '',
          cafeName: '',
          link1Name: '',
          channelTalk: 'http://pf.kakao.com/_sGRqX/chat',
          kakaoChat: '',
          naverCafe: '',
          link1Link: '',
          Link1Image: ''
        }
      };
    },
    navListProcessed() {
      const host = window.location.hostname;

      const domainLinks = this.domainLinkOverrides[Object.keys(this.domainLinkOverrides).find(domain => host.includes(domain))] || {};

      // stock.overlink.kr이면 재고관리, 재고관리리포트만 표시
      const isStockDomain = host === 'stock.overlink.kr';
      const stockOnlyLinks = ['inventoryLinked', 'inventoryLinked_blank', 'stockLinkReport', 'stockLinkReport_blank'];

      return this.navList.filter(group => {
        // stock.overlink.kr이면 재고관리 항목이 있는 그룹만 표시
        if (isStockDomain) {
          return group.items.some(item => stockOnlyLinks.includes(item.link));
        }

        // 기능 실험실"은 특정 userId에게만 보이게
        if (group.group === '기능 실험실') {
          const allowedUserIds = ['pirate17', 'qnwnen22']; //  허용할 userId 배열
          return allowedUserIds.includes(this.userInfo?.userId);
        } else if (group.group === '작업관리') {
          const allowedUserIds = ['pirate17', 'qnwnen22']; //  허용할 userId 배열
          return allowedUserIds.includes(this.userInfo?.userId);
        }
        return true; // 나머지 그룹은 모두 표시
      }).map(group => ({
        ...group,
        items: group.items
          .filter(item => {
            // stock.overlink.kr이면 재고관리 관련 항목만 표시
            if (isStockDomain) {
              return stockOnlyLinks.includes(item.link);
            }

            const allowedUserIds = ['pirate17', 'simcoms', 'chanol06', 'qnwnen22']; //  allowedUserIds 재사용
            // 매출통계 제거
            // 매출통계 항목은 특정 userId에게만 보이게
            if (['statistics', 'statistics_blank'].includes(item.link)) {
              return allowedUserIds.includes(this.userInfo?.userId);
            }

            // smartcross.kr일 때 오픈채팅과 카페 항목 숨기기
            if (host.includes('smartcross.kr')) {
              // 오픈채팅 항목 숨기기 (이름에 '오픈채팅' 포함 또는 링크가 오픈채팅 링크)
              if (item.name && item.name.includes('오픈채팅')) {
                return false;
              }
              if (item.link && item.link.includes('open.kakao.com') && item.link !== 'https://open.kakao.com/o/szAbTibi') {
                return false;
              }
              // 카페 항목 숨기기 (이름에 '카페' 포함 또는 링크가 네이버 카페)
              if (item.name && item.name.includes('카페')) {
                return false;
              }
              if (item.link && item.link.includes('cafe.naver.com')) {
                return false;
              }
            }

            // 재고관리리포트는 osonupload.com, localhost, stock.overlink.kr에서만 표시
            if (['stockLinkReport', 'stockLinkReport_blank'].includes(item.link)) {
              return host.includes('osonupload.com') || host === 'localhost' || host === 'stock.overlink.kr';
            }

            // 특정 ID에게만 보여야 하는 항목 처리
            if (item.visibleTo && !item.visibleTo.includes(this.userInfo.userId)) return false;

            return true;
          })
          .map(item => {
            let newItem = { ...item };

            //링크 및 타이틀 치환 로직은 동일하게 유지
            newItem.name = item.name?.replace(/셀리오마켓/g, this.menuname);

            if (item.link === 'https://solutionno1.channel.io' && domainLinks.channelTalk) {
              newItem.link = domainLinks.channelTalk;
            }
            if (item.link === 'https://open.kakao.com/o/gpj6dKVe' && domainLinks.kakaoChat) {
              newItem.link = domainLinks.kakaoChat;
            }
            if (item.link === 'https://cafe.naver.com/gucademy' && domainLinks.naverCafe) {
              newItem.link = domainLinks.naverCafe;
            }
            if (item.link === 'https://link1' && domainLinks.link1Link) {
              newItem.link = domainLinks.link1Link;
            }
            if (item.name === '상담하러가기' && domainLinks.talkName) {
              newItem.name = domainLinks.talkName;
            }
            if (item.name === '셀리오마켓 오픈채팅' && domainLinks.kakaoName) {
              newItem.name = domainLinks.kakaoName;
            }
            if (item.name === '셀리오마켓 카페' && domainLinks.cafeName) {
              newItem.name = domainLinks.cafeName;
            }
            if (item.name === '링크1' && domainLinks.link1Name) {
              newItem.name = domainLinks.link1Name;
              newItem.image = domainLinks.Link1Image;
            }

            return newItem;
          })
      }));
    },
    currentMenu() {
      // 현재 라우트에 해당하는 메뉴 찾기
      const currentRouteName = this.$route.name;
      const currentPath = this.$route.path;

      // 1. routeName으로 정확히 일치하는 메뉴 찾기
      for (const group of this.navListProcessed) {
        for (const item of group.items) {
          if (item.routeName === currentRouteName && item.name !== '[새창 열기]') {
            return item;
          }
        }
      }

      // 2. routeName이 없으면 경로로 찾기
      for (const group of this.navListProcessed) {
        for (const item of group.items) {
          if (item.name !== '[새창 열기]' && item.link) {
            const menuPath = `/app/${item.link}`;
            // 경로가 정확히 일치하거나, 경로의 일부가 일치하는 경우
            if (currentPath === menuPath || currentPath.startsWith(menuPath + '/')) {
              return item;
            }
          }
        }
      }

      // 3. 경로에서 link 부분 추출해서 찾기
      const pathParts = currentPath.split('/');
      if (pathParts.length >= 3) {
        const linkPart = pathParts.slice(2).join('/'); // /app/ 이후 부분
        for (const group of this.navListProcessed) {
          for (const item of group.items) {
            if (item.name !== '[새창 열기]' && item.link && linkPart.startsWith(item.link)) {
              return item;
            }
          }
        }
      }

      return null;
    },
    isCurrentMenuFavorite() {
      if (!this.currentMenu) return false;
      return this.favoriteMenus.some(fav => fav.menuLink === this.currentMenu.link);
    },
    isOverlinkHost() {
      const host = window.location.hostname;
      return host.includes('overlink.kr') || host.includes('omarket.kr');
    },
    isSiteOverlink() {
      const host = window.location.hostname;
      return host === 'stock.overlink.kr' || host === 'localhost' || host.includes('kimmanager.co.kr') || host.includes('osonupload.com');
    }
  },
  data() {
    return {
      expandedGroups: {}, // 그룹별 접기/펼치기 상태
      favoriteMenus: [], // 즐겨찾기 메뉴 목록
      isFavoriteExpanded: true, // 즐겨찾기 그룹 펼침 상태
      userInfo: {
        data: {
          hiddensite: [] // 기본값으로 빈 배열을 설정
        }
      },
      navList: [
        {
          group: '상품관리',
          items: [
            { name: '소싱 키워드마스터', routeName: '추천 소싱 키워드', link: 'productRecommend', image: 'collectSetting' },
            { name: '[새창 열기]', routeName: '추천 소싱 키워드_blank', link: 'productRecommend_blank' },
            { name: '일반 소싱상품관리', routeName: '일반 소싱상품관리', link: 'productSetting', image: 'collectSetting' },
            { name: '[새창 열기]', routeName: '일반 소싱상품관리_blank', link: 'productSetting_blank' },
            { name: '비공개 소싱상품관리', routeName: '비공개 소싱상품관리', link: 'privateproductSetting', image: 'collectSetting' },
            { name: '[새창 열기]', routeName: '비공개 소싱상품관리_blank', link: 'privateproductSetting_blank' },
            { name: '전세계 사이트수동소싱', routeName: '전세계사이트 수동소싱', link: 'manualProductSetting', image: 'collectSetting' },
            { name: '[새창 열기]', routeName: '전세계 사이트수동소싱_blank', link: 'manualProductSetting_blank' },
            { name: '소싱상품수집', routeName: '소싱상품수집', link: 'ProductManagement', image: 'collectManagement' },
            { name: '[새창 열기]', routeName: '소싱상품수집_blank', link: 'ProductManagement_blank' },
            { name: '브랜드상품소싱', routeName: '브랜드 소싱상품관리', link: 'luxProductSetting', image: 'luxProductSetting' },
            { name: '[새창 열기]', routeName: '브랜드 소싱상품관리_blank', link: 'luxProductSetting_blank' },
            { name: '마켓 상품 가져오기', routeName: '마켓 상품 가져오기', link: 'marketProduct', image: 'marketProduct' },
            { name: '[새창 열기]', routeName: '마켓 상품 가져오기_blank', link: 'marketProduct_blank' },
            { name: '등록전상품관리', routeName: '등록전 상품관리(상품전송)', link: 'standbyProduct', image: 'standbyProduct' },
            { name: '[새창 열기]', routeName: '등록전 상품관리(상품전송)_blank', link: 'standbyProduct_blank' },
            { name: '등록 상품관리', routeName: '등록상품관리', link: 'registeredProduct', image: 'registProduct' },
            { name: '[새창 열기]', routeName: '등록상품관리_blank', link: 'registeredProduct_blank' },
            { name: '재고관리', routeName: '재고관리', link: 'inventoryLinked', image: 'stockLinakage' },
            { name: '[새창 열기]', routeName: '재고관리_blank', link: 'inventoryLinked_blank' },
            { name: 'AI업로드', routeName: 'AI업로드', link: 'aiUpload', image: 'collectManagement' },
            { name: '[새창 열기]', routeName: 'AI업로드_blank', link: 'aiUpload_blank' }
          ]
        },
        {
          group: '기능 실험실',
          items: [
            { name: '쇼피', routeName: '쇼피', link: 'shopee', image: 'orderManagement' },
            { name: '[새창 열기]', routeName: '쇼피_blank', link: 'shopee_blank' }
          ]
        },
        {
          group: '주문관리',
          items: [
            { name: '주문관리', routeName: '주문관리', link: 'ordermanagement', image: 'orderManagement' },
            { name: '[새창 열기]', routeName: '주문관리_blank', link: 'ordermanagement_blank' },
            {
              name: '주문상품조회',
              routeName: '주문상품조회',
              link: 'orderItemSearch',
              image: 'orderManagement',
              visibleTo: [
                'whitekws100',
                'hooni',
                'parksk78',
                'a_b_caa1',
                'wnq10',
                'minam',
                'is1105',
                'skylove441',
                'joypop',
                'jyg09791',
                'simcoms',
                'pirate17'
              ]
            },
            {
              name: '[새창 열기]',
              routeName: '주문상품조회_blank',
              link: 'orderItemSearch_blank',
              visibleTo: [
                'whitekws100',
                'hooni',
                'parksk78',
                'a_b_caa1',
                'wnq10',
                'minam',
                'is1105',
                'skylove441',
                'joypop',
                'jyg09791',
                'simcoms',
                'pirate17'
              ]
            },
            { name: '매출통계', routeName: '매출통계', link: 'statistics', image: 'statistics' },
            { name: '[새창 열기]', routeName: '매출통계_blank', link: 'statistics_blank' },
            { name: '부가세신고자료생성', routeName: '부가세신고자료생성', link: 'vatReport', image: 'statistics' },
            { name: '[새창 열기]', routeName: '부가세신고자료생성_blank', link: 'vatReport_blank' }
          ]
        },
        {
          group: '셀링 리포트',
          items: [
            { name: '상품리포트', routeName: '상품리포트', link: 'productReport', image: 'registProduct' },
            { name: '[새창 열기]', routeName: '상품리포트_blank', link: 'productReport_blank' },
            { name: '조회수리포트', routeName: '상품조회수분석', link: 'productViewAnalysis', image: 'statistics' },
            { name: '[새창 열기]', routeName: '상품조회수분석_blank', link: 'productViewAnalysis_blank' },
            { name: '매출리포트', routeName: '매출리포트', link: 'salesReport', image: 'orderManagement' },
            { name: '[새창 열기]', routeName: '매출리포트_blank', link: 'salesReport_blank' },
            { name: '재고관리리포트', routeName: '재고관리리포트', link: 'stockLinkReport', image: 'statistics' },
            { name: '[새창 열기]', routeName: '재고관리리포트_blank', link: 'stockLinkReport_blank' }
          ]
        },
        {
          group: '템플릿',
          items: [
            { name: '상품 템플릿', routeName: '상품 템플릿', link: 'template/image', image: 'imageTemplate' },
            { name: '[새창 열기]', routeName: '상품 템플릿', link: 'template/image_blank' },
            { name: '마진 템플릿', routeName: '마진 템플릿', link: 'template/upload', image: 'uploadTemplate' },
            { name: '[새창 열기]', routeName: '마진 템플릿', link: 'template/upload_blank' },
            { name: '단어설정 템플릿', routeName: '단어설정 템플릿', link: 'template/word', image: 'wordTemplate' },
            { name: '[새창 열기]', routeName: '단어설정 템플릿', link: 'template/word_blank' },
            //{name: "AI프롬프트 템플릿", routeName: "AI프롬프트 템플릿", link: "template/AI", image: "wordTemplate"},
            //{name: "[새창 열기]", routeName: "AI프롬프트 템플릿", link: "template/AI_blank"},
            { name: '마켓별 템플릿', routeName: '마켓별 템플릿', link: 'template/market', image: 'marketTemplate' },
            { name: '[새창 열기]', routeName: '마켓별 템플릿', link: 'template/market_blank' },
            { name: 'CS 템플릿', routeName: 'CS 템플릿', link: 'template/CSTemplate', image: 'csTemplate' },
            { name: '[새창 열기]', routeName: 'CS 템플릿', link: 'template/CSTemplate_blank' }
          ]
        },
        {
          group: '마이페이지',
          items: [
            { name: '선정산(준비중)', routeName: '선정산', link: 'vitapay', image: 'settings' },
            { name: '[새창 열기]', routeName: '선정산_blank', link: 'vitapay_blank' },
            { name: '환경설정', routeName: '환경설정', link: 'preferences', image: 'settings' },
            { name: '[새창 열기]', routeName: '환경설정_blank', link: 'preferences_blank' },
            { name: '직원계정관리', routeName: '직원계정관리', link: 'subUserManagement', image: 'settings' },
            { name: '[새창 열기]', routeName: '직원계정관리_blank', link: 'subUserManagement_blank' },
            { name: '상품 오토파일럿', routeName: '상품 오토파일럿', link: 'marketAutoSetting', image: 'settings' },
            { name: '[새창 열기]', routeName: '마켓대량연동설정_blank', link: 'marketAutoSetting_blank' },
            { name: '벌크마켓업로드', routeName: '벌크마켓업로드', link: 'bulkMarketUpload', image: 'settings' },
            { name: '[새창 열기]', routeName: '벌크마켓업로드_blank', link: 'bulkMarketUpload_blank' },
            {
              name: '상품수집현황',
              routeName: '상품대시보드',
              link: 'ProductDashBoard',
              image: 'settings',
              visibleTo: ['simcoms', 'simcoms7907']
            },
            {
              name: '[새창 열기]',
              routeName: '상품대시보드_blank',
              link: 'ProductDashBoard_blank',
              visibleTo: ['simcoms', 'simcoms7907']
            }
          ]
        },
        {
          group: '고객센터',
          items: [
            { name: '상담하러가기', routeName: '#', link: 'https://solutionno1.channel.io', image: 'managementCenter' },

            { name: '셀리오마켓 오픈채팅', routeName: '#', link: 'https://open.kakao.com/o/gpj6dKVe', image: 'kakaotalk' },

            { name: '셀리오마켓 카페', routeName: '#', link: 'https://cafe.naver.com/gucademy', image: 'naverCafe' },

            // {name: "링크1", routeName: "#", link: "https://link1", image: "linkImage1"},


            {
              name: '사용자 가이드',
              routeName: '#',
              link: 'https://www.notion.so/154e8c3bbf37802aad9be8232d11abd8?v=cec44187139e452295f58aa393e066cd',
              image: 'userGuide'
            }
          ]
        }, {
          group: '작업관리',
          items: [
            { name: '소켓 관리', routeName: '소켓 관리', link: 'socketManagement', image: 'collectSetting' }
            // { name: '작업 관리', routeName: '작업 관리', link: 'workManagement', image: 'kakaotalk' }
          ]
        }
      ]
    };
  }
};
</script>

<style lang="scss">
@import '@/assets/style/app/layout/sidebar.scss';
</style>